import { gql } from '@apollo/client';
import React from 'react';
import { Input } from '@moda/om';
import { ProductCustomizationFragment } from '../../generated/types/ProductCustomizationFragment';
import './ProductCustomization.scss';

type ProductCustomizationProps = {
  customizationMessage: string;
  customizationMessageError: string;
  customizationParameters: ProductCustomizationFragment;
  onChange: (evt: React.ChangeEvent<HTMLInputElement>) => void;
};

export const PRODUCT_CUSTOMIZATION_FRAGMENT = gql`
  fragment ProductCustomizationFragment on CustomizationParameters {
    characterClass: character_class
    displayText: display_text
    maxLength: max_length
    minLength: min_length
    required
  }
`;

export const ProductCustomization: React.FC<ProductCustomizationProps> = ({
  customizationMessage,
  customizationMessageError,
  customizationParameters,
  onChange
}) => (
  <div className="ProductCustomization">
    <div className="ProductCustomization__length">
      Personalized Message{' '}
      {customizationParameters.maxLength &&
        `(${customizationMessage.length}/${customizationParameters.maxLength})`}
      {!customizationParameters.required && ' - Optional'}
    </div>

    <Input
      className="ProductCustomization__input"
      error={customizationMessageError}
      label={customizationParameters.displayText || ''}
      maxLength={customizationParameters.maxLength || undefined}
      onChange={onChange}
    />
  </div>
);
